import React from 'react';
import { AnswerStreamSubjectType } from './types';

export type AnswerStreamSubject = {
  subjectType: AnswerStreamSubjectType;
  subjectId: number;
};

const AnswerStreamSubjectContext = React.createContext<AnswerStreamSubject | null>(
  null
);

export function AnswerStreamSubjectProvider({
  subject,
  children,
}: {
  subject: AnswerStreamSubject | null;
  children: React.ReactNode;
}) {
  return (
    <AnswerStreamSubjectContext.Provider value={subject}>
      {children}
    </AnswerStreamSubjectContext.Provider>
  );
}

export function useAnswerStreamSubject(): AnswerStreamSubject | null {
  return React.useContext(AnswerStreamSubjectContext);
}
